import {Component, OnInit} from '@angular/core';
import * as packageJSON from '../../../package.json';

@Component({
    selector: 'app-about-app',
    templateUrl: './about-app.component.html',
    styleUrls: ['./about-app.component.scss']
})
export class AboutAppComponent {
    public package_data: any = packageJSON;
}
